import { EServiceType } from '../../../../redux/reducers';
import { IRecommendedServicePackageServiceSchema } from '../../../../repositories/billing-tariffs/v1/publish-terms';
import { IRecommendedPackageService } from '../../../../types/reducers/recommendedPackages';
import { mapRecommendedPackageService } from './mapRecommendedPackageService';

export const mapRecommendedPackageServices = (
  services: Array<IRecommendedServicePackageServiceSchema>,
): Array<IRecommendedPackageService> => {
  return services
    .map(mapRecommendedPackageService)
    .filter(({ serviceType }) => [EServiceType.paid, EServiceType.auction].includes(serviceType)); // убираем невалидные сервисы из пакета
};
